import { HttpFilter } from 'sol-request-angular/dist/comunicacao';
import { Equal } from 'sol-request-angular/dist/comunicacao/filter/Equal';
import { FilterEqual } from 'sol-request-angular/dist/comunicacao/filter/FilterEqual';
import { IFilter } from 'sol-request-angular/dist/comunicacao/interfaces/IFilter';

export class TaxiParadaSearch {

    cdPonto: number;
    cdParada: number;
    nrParada: string;
    cdConcessao: number;
    tpConcessao: number;
    idPonto: string;
    page: number;
    limit: number;
    cdConcessionario: number;
    cdConcessaoIsNull: boolean;

    constructor(data?: {
        cdPonto?: number,
        cdParada?: number,
        nrParada?: string,
        cdConcessao?: number,
        tpConcessao?: number,
        idPonto?: string,
        cdConcessionario?: number,
        cdConcessaoIsNull?: boolean,
        page?: number,
        limit?: number
    }) {
        this.cdPonto = data && data.cdPonto;
        this.cdParada = data && data.cdParada;
        this.nrParada = data && data.nrParada;
        this.cdConcessao = data && data.cdConcessao;
        this.tpConcessao = data && data.tpConcessao;
        this.idPonto = data && data.idPonto;
        this.cdConcessionario = data && data.cdConcessionario;
        this.cdConcessaoIsNull = data && data.cdConcessaoIsNull;
        this.page = data && data.page;
        this.limit = data && data.limit;
    }

    getFilters(): IFilter{
        let filtros: IFilter = new HttpFilter([]);

        if(this.cdPonto){
            filtros.addFilter(new Equal('cdPonto', this.cdPonto));
        }
        
        if(this.cdParada){
            filtros.addFilter(new Equal('cdParada', this.cdParada));
        }
        
        if(this.nrParada){
            filtros.addFilter(new Equal('nrParada', this.nrParada));
        }

        if(this.cdConcessao){
            filtros.addFilter(new Equal('cdConcessao', this.cdConcessao));
        }

        if(this.tpConcessao && this.tpConcessao != null){
            filtros.addFilter(new Equal('tpConcessao', this.tpConcessao));
        }

        if(this.cdConcessionario){
            filtros.addFilter(new Equal('cdConcessionario', this.cdConcessionario));
        }

        if(this.cdConcessaoIsNull){
            filtros.addFilter(new Equal('cdConcessaoIsNull', this.cdConcessaoIsNull));
        }

        if(this.idPonto){
            filtros.addFilter(new Equal('idPonto', this.idPonto));
        }

        if(this.page > -1){
            filtros.addFilter(new Equal('page', this.page));
        }

        if(this.limit > 0){
            filtros.addFilter(new Equal('limit', this.limit));
        }
        
        return filtros;
    }
}